<template>
    <section class="vue-winwheel" :class="is_active ? 'modal-active' : ''">
      <div class="mobile-container" v-if="isMobile">
        <div class="info"><p>Đã hết thời gian tham gia </p>
        <p><span class="detail" @click.prevent="showHistory()">Xem chi tiết lượt quay</span></p></div>
        
        <div class="wheel-wrapper">
          <div class="canvas-wrapper">
            <canvas id="canvas" width="340" height="340">
              <p style="{color: white}" align="center">Sorry, your browser doesn't support canvas. Please try Google Chrome.</p>
            </canvas>
            <a @click.prevent="startSpin()" v-if="!wheelSpinning">
              <img src="@/assets/img/mobile.png" alt="">
            </a>
          </div>
        </div>
      </div>
      <div id="modal-container" :class="is_active ? 'one' : ''">
        <div class="modal-background">
          
          <div class="modal popup" v-if="data['rwd'] == 1">
            <div class="close" @click.prevent="close()"><img src="./assets/img/close.png" alt=""></div>
            <p class="title">chúc mừng<br>bạn nhận được</p>
            <span v-if="(position + 1) == 4 ">Mã Dự Thưởng</span>
            <img v-bind:src="reward[position]" alt="" :style="position == 7 ? 'width: 23%' : ''">
            <p class="description">Kiểm tra mục tin nhắn<br>để biết mã dự thưởng của mình bạn nhé!</p>
            <p class="footer">Xem chi tiết lịch sử quay</p>
            <span class="detail" @click.prevent="showHistory()">Tại đây</span>
          </div>
          <div class="modal popup failed" v-if="data['rwd'] == 0">
            <div class="close" @click.prevent="close()"><img src="./assets/img/close.png" alt=""></div>
            <p class="title">Chúc bạn may mắn lần sau</p>
            <p class="footer">Xem chi tiết lịch sử quay</p>
            <span class="detail" @click.prevent="showHistory()">Tại đây</span>
          </div>
          <div class="modal histories" v-if="data['rwd'] == 2">
            <div class="close" @click.prevent="close()"><img src="./assets/img/close.png" alt=""></div>
            <div class="title">
              Lịch sử quay nón
            </div>
            <div class="content">
              <table align="center" style="margin: 10px auto;">
                <tr v-for="history in histories" :key="history.id">
                  <td width="120px" v-if="history.type == 'MADUTHUONG'">
                    Mã dự thưởng
                  </td>
                  <td width="120px" v-else-if="history.type == 'CHUCBANMAYMAN'">
                    Rất tiếc !!!
                  </td>
                  <td width="120px" v-else-if="history.type == 'TOTE'">
                      Tote
                  </td>
                  <td width="120px" v-else-if=" history.type == 'TCH'">
                      Mã TCH
                  </td>
                  <td width="120px" v-else>
                    Mã AhaMove
                  </td>

                  <td v-if="history.type == 'MADUTHUONG'">
                      Bạn nhận được mã: {{('0000000'+history.note).slice(-6)}}
                  </td>
                  <td v-else-if="history.type == 'CHUCBANMAYMAN'">
                    Chúc bạn may mắn lần sau
                  </td>
                  <td v-else-if="history.type == 'TOTE'">
                    Bạn nhận túi Tote
                  </td>
                  <td v-else>
                    Bạn nhận được mã : {{history.note}}
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
        
      </div>
      <div v-if="!isMobile" class="desk-container" :class="is_active ? 'modal-active' : ''">
        <div class="wheel-wrapper">
          <div class="canvas-wrapper">
            <canvas id="canvas" width="340" height="340">
              <p style="{color: white}" align="center">Sorry, your browser doesn't support canvas. Please try Google Chrome.</p>
            </canvas>
            <a @click.prevent="startSpin()" v-if="!wheelSpinning">
              <img src="@/assets/img/mobile.png" alt="">
            </a>
          </div>
        </div>
        <div class="info"><p>Đã hết thời gian tham gia </p>
          <p><span class="detail" @click.prevent="showHistory()">Xem chi tiết lượt quay</span></p></div>
      </div>
      </div>
    </section>
</template>


<script>
import * as Winwheel from './Winwheel'
import turn_service from './service'
import { isMobile } from 'mobile-device-detect';
import moment from 'moment-timezone'

export default {
name: 'VueWinWheel',
props:{
	segments:{
		default(){
			return [
				{
					textFillStyle: '#fff',
					fillStyle: '#000',
					text:'Prize 1'
				},
				{
					textFillStyle: '#000',
					fillStyle: '#fadede',
					text:'Prize 2'
				},
				{
					textFillStyle: '#fff',
					fillStyle: '#000',
					text:'Prize 3'
				},
				{
					textFillStyle: '#000',
					fillStyle: '#fadede',
					text:'Prize 4'
				},
				{
					textFillStyle: '#fff',
					fillStyle: '#000',
					text:'Prize 5'
				},
				{
					textFillStyle: '#000',
					fillStyle: '#fadede',
					text:'Prize 6'
				},
				{
					textFillStyle: '#fff',
					fillStyle: '#000',
					text:'Prize 7'
				},
				{
					textFillStyle: '#000',
					fillStyle: '#fadede',
					text:'Prize 8'
				},
			]
		}
	},
	token: ''
},
data () {
return {
  user: {
	  turn: 0,
	  use_turn: 0
  },
  reward: [
	  '/img/30.png','/img/10.png','/img/50.png','/img/code.png','/img/7k.png','/img/20.png','/img/tch.png','/img/tote.png',
	  ],
  is_active: false,
  position: 0,
  loadingPrize: false,
  theWheel: null,
  modalPrize: false,
  wheelPower: 1,
  wheelSpinning: false,
  prizeName: 'BUY 1 GET 1',
  WinWheelOptions: {
    textFontSize: 14,
    outterRadius: 410,
    innerRadius: 25,
    lineWidth: 8,
    // drawMode: 'code',
    // numSegments: 9,
    drawMode: 'segmentImage',
    animation: {
      type: 'spinOngoing',
      duration: 0.5
    },
  },
  data: {
    rwd: 2,

  },
  isSpin: false,
  isMobile: isMobile,
  histories: []
}
},
methods: {
get() {
	let payload = {
		token: this.token
	}
	turn_service.get_turn(payload)
	.then((res) => {
		this.user = res.body
	})
	.catch((err) => {
		
	})
},
turn_around() {
	return new Promise((resolve, reject) => {
		let payload = {
			token: this.token
		}
		turn_service.turn_around(payload)
		.then((res) => {
			resolve(res)
		})
		.catch((err) => {
			reject(err)
		})
	})
	
},
showPrize () {
  this.modalPrize = true
},
hidePrize () {
  this.modalPrize = false
},
async startSpin () {
  if (this.isSpin){
    return
  }
  try {
    var res = await this.turn_around()
	} catch(e) {
    // console.log(e)
    return
	}
  this.user = res.body.user
  this.data = res.body.data
  this.isSpin = true
  if (this.wheelSpinning === false) {
	this.theWheel.startAnimation()
	this.wheelSpinning = true
	this.theWheel = new Winwheel.Winwheel({
	  ...this.WinWheelOptions,
	  numSegments: this.segments.length,
	  segments: this.segments,
	  animation: {
		type: 'spinToStop',
		duration: 10,
		spins: 10,
		callbackFinished: this.onFinishSpin
	  }
	})

	// example input prize number get from Backend
	// Important thing is to set the stopAngle of the animation before stating the spin.
	let position = res.body.data.assign

	let start = position*45 - 45 + 1;
	let stop = Math.floor((Math.random() * 43)); //Giá trị cao nhất 44
	let stopAt = start + stop;
	// var prizeNumber = Math.floor(Math.random() * this.segments.length) // or just get from Backend
	// var stopAt = 360 / this.segments.length * prizeNumber - 360 / this.segments.length / 2 // center pin
	// var stopAt = 360 / this.segments.length * prizeNumber - Math.floor(Math.random() * 60) //random location
	// console.log(this.segments.length)
	this.theWheel.animation.stopAngle = stopAt
	this.theWheel.startAnimation()
	this.wheelSpinning = false
	this.position = position - 1
  }
},
resetWheel () {
  this.theWheel = new Winwheel.Winwheel({
	...this.WinWheelOptions,
	numSegments: this.segments.length,
	segments: this.segments
  })

  if (this.wheelSpinning) {
	this.theWheel.stopAnimation(false) // Stop the animation, false as param so does not call callback function.
  }

  this.theWheel.rotationAngle = 0 // Re-set the wheel angle to 0 degrees.
  this.theWheel.draw() // Call draw to render changes to the wheel.
  this.wheelSpinning = false // Reset to false to power buttons and spin can be clicked again.
},
initSpin () {
  this.loadingPrize = true
		this.resetWheel()
		this.loadingPrize = false
},
onFinishSpin (indicatedSegment) {
  this.prizeName = indicatedSegment.text
  this.showPrize()
  this.is_active = true
  this.isSpin = false
  
},
showHistory() {
  this.is_active = true
  let payload = {
    token: this.token
  }
  turn_service.get_histories(payload)
  .then((res) => {
    this.histories = res.body
    this.data['rwd'] = 2
    
  })
  .catch((err) => {
    console.log(err)
    this.histories = []
  })
},
close() {
	this.is_active = false
},
check_date() {
  var now = new Date()
  var start_date = new moment('2020-08-17T00:00:00Z').tz('Asia/Ho_Chi_Minh')
  var end_date = new moment('2020-08-20T00:00:00Z').tz('Asia/Ho_Chi_Minh')
  now = moment(now).tz('Asia/Ho_Chi_Minh')
  if ( start_date < now && now < end_date) {
    console.log("aaaa")
  }else {
    console.log("bbb")
  }
}
},
computed: {},
updated () {},
mounted () {
this.initSpin()
this.check_date()
this.get()
// this.showHistory()
// this.resetWheel()
},
created () {}
}

</script>

<style scoped>
* {
  touch-action: manipulation;
}
.close{
	position: absolute;
    top: -13px;
    right: -13px;
}
.popup {
	background: url('./assets/img/bg_popup.png') !important;
	background-size: cover;
	height: 448px;
	padding-top: 95px !important;
	width: 314px;
}
.popup p {
	padding-bottom: 0;
	margin-bottom: 0;
}
.popup span {
	display: block;
  background: #00467f;
  color: #FFF;
  padding: 8px 0 5px;
  font-size: 14px;
  font-weight: bold;
	margin: 5px auto 0;
	width: 60%;
	text-transform: uppercase;
}
.desk-container .info {
  color: #FFF;
    font-size: 30px;
    font-weight: bold;
    position: absolute;
    left: 110px;
    top: calc(100% - 280px);
}
.desk-container .info span {
  color: #faba36;
  font-size: 38px;
}
.desk-container .info span.detail {
  font-size: 30px;
  background: #faba36;
  border-radius: 50px;
  padding: 10px 30px 8px;
  color: #00467f;
  cursor: pointer;
}
.popup > img {
	width: 55%;
  padding: 5px 0;
}
.popup .title {
	font-size: 16px !important;
	text-transform: uppercase;
	font-weight: bold;
	font-family: 'Brown';
	color: #f66601;
}
.histories {
  padding: 0 !important;
  width: 85% !important ;
  max-width: 600px;
}
.histories .content {
  height: 448px;
  overflow-y: scroll;
  padding: 3px;
}
.histories .title {
  background: #f66601;
  color: #FFF;
  font-size: 26px;
  font-weight: bold;
  padding: 8px 0 5px;
  line-height: 40px;
}
.histories td {
  text-align: left;
  line-height: 20px;
  border-collapse: collapse;
  border: 1px solid #CCC;
  padding: 3px;
}
table {
  border-collapse: collapse;

}
.failed .title {
  width: 61%;
  margin: 45px auto;
  font-size: 27px !important;
  line-height: 30px !important;
}
.popup .description {
	font-size: 12px !important;
	color: #000;
	font-weight: bold;
	margin-top: 5px;
}
.popup .footer {
	color: #f66601;
	font-size: 11px !important;
	font-weight: bold;
	margin-top: 0;
}
.popup .detail {
	background: #f66601;
	color: #FFF;
	font-weight: bold;
	border-radius: 50px 50px;
	width: 40%;
}
.vue-winwheel {
text-align: center;
/* background-image: url('/static/img/obstacle-run/bg-spinner-mobile.svg'); */
background-size: 100%;
background-repeat: no-repeat;

width: 100vw;
height: 100vh;
}
.vue-winwheel h1 {
color: #b32656;
font-family: 'Avenir', Helvetica, Arial, sans-serif;
font-size: 36px;
line-height: 90px;
letter-spacing: 4px;
margin: 0;
}
.vue-winwheel h2 {
margin: 0;
}
.vue-winwheel #modalSpinwheel.custom-modal .content-wrapper .content {
width: calc(100vw - 30px);
padding-top: 52px;
}
.vue-winwheel #modalSpinwheel.custom-modal .content-wrapper .content h2 {
text-transform: uppercase;
color: #b32656;
margin-bottom: 16px;
margin-top: 0;
font-family: 'Avenir', Helvetica, Arial, sans-serif;
font-size: 18px;
letter-spacing: 1.1px;
margin: 0;
}
.vue-winwheel #modalSpinwheel.custom-modal .content-wrapper .content p {
font-family: 'Avenir', Helvetica, Arial, sans-serif;
font-size: 14px;
color: black;
text-align: center;
line-height: 25px;
}
.vue-winwheel #modalSpinwheel.custom-modal .content-wrapper .content p strong {
font-family: 'Avenir', Helvetica, Arial, sans-serif;
}
.vue-winwheel #modalSpinwheel.custom-modal .content-wrapper .content .modal-dismiss {
top: 12px;
right: 12px;
}
.vue-winwheel #modalSpinwheel.custom-modal .content-wrapper .content .modal-dismiss i.icon_close {
font-size: 30px;
color: #da2a52;
}
.vue-winwheel canvas#canvas {
position: relative;
}
.vue-winwheel .canvas-wrapper {
position: relative;
}
.vue-winwheel a {
	content: '';
	display: block;
	width: 91px;
	/* background: #c4376f; */
	height: 74px;
	position: absolute;
	left: calc(50% - 47px);
	margin: auto;
	border-radius: 100%;
	top: calc(50% - 39px);
	/* border: 5px solid white; */
	box-sizing: content-box;
  cursor: pointer;
}
.vue-winwheel .canvas-wrapper:before {
content: '';
display: block;
width: 340px;
background:url("./assets/img/non.png");
height: 340px;
position: absolute;
left: 0;
right: 0;
margin: 0 auto;
border-radius: 100%;
top: 0;
transform: rotate(22deg);
}
.vue-winwheel .wheel-wrapper {
position: relative;
top: 0;
}
.vue-winwheel .wheel-wrapper:before {
content: '';
width: 62px;
height: 47px;
position: absolute;
top: -10px;
left: calc(50% - 31px);
right: 0;
display: block;
z-index: 99999;
background-image: url('./spinner-marker.svg');
background-repeat: no-repeat;
background-size: contain;
background-position: center;
}
.vue-winwheel .wheel-wrapper .button-wrapper {
margin: 0 auto;
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
width: 231px;
height: 118px;
}
.vue-winwheel .wheel-wrapper .btn.btn-play {
padding: 0 58px !important;
background: #c4376f;
height: 40px;
line-height: 40px;
color: white;
font-weight: bold;
text-decoration: none;
border-radius: 2px;
letter-spacing: 2px;
}
.vue-winwheel .mobile-container {
	padding-top: 50%;
  background-size: 100%;
  background-repeat: no-repeat;
  background-image: url('./assets/img/bg.png');
  width: 100vw;
  height: 100vh;
  margin-top: -50px;
}
.vue-winwheel .desk-container {
  /* background-size: 100% 0\; */
  background-size: 100%;
  background-repeat: no-repeat;
  background-image: url('./assets/img/bg_desk.png');
  width: 100vw;
  max-width: 1200px;
  min-width: 900px;
  height: 700px;
  position: relative;
  margin: 0 auto;
}
.vue-winwheel .desk-container .wheel-wrapper {
  position: absolute;
  left: calc(100% - 515px);
  top: calc(100% - 500px);
}
.vue-winwheel .mobile-container .info {
	color: #FFF;
	font-size: 20px;
	font-weight: bold;
}
.vue-winwheel .mobile-container .info p {
	padding-bottom: 0;
}
.vue-winwheel .mobile-container .info span {
	font-size: 25px;
	color: #faba36;
}
.vue-winwheel .mobile-container .info span.detail {
	font-size: 18px;
	display: block;
	background: #faba36;
	border-radius: 50px;
	width: 70%;
	margin: 0 auto;
	color: #00467f;
	padding: 10px 0;
}
</style>
<style lang="scss">
* {
  box-sizing:border-box;
}

html,body {
  min-height:100%;
  height:100%;
  background: #000;
  font-weight:200;
  &.modal-active {
    overflow: hidden;
  }
}

#modal-container {
  position:fixed;
  display:table;
  height:100%;
  width:100%;
  top:0;
  left:0;
  transform:scale(0);
  z-index:999999;
  &.one {
    transform:scaleY(.01) scaleX(0);
    animation:unfoldIn 1s cubic-bezier(0.165, 0.840, 0.440, 1.000) forwards;
    .modal-background {
      .modal {
        transform:scale(0);
        animation: zoomIn .5s .8s cubic-bezier(0.165, 0.840, 0.440, 1.000) forwards;
      }
    }
    &.out {
      transform:scale(1);
      animation:unfoldOut 1s .3s cubic-bezier(0.165, 0.840, 0.440, 1.000) forwards;
      .modal-background {
        .modal {
          animation: zoomOut .5s cubic-bezier(0.165, 0.840, 0.440, 1.000) forwards;
        }
      }
    }
  }
  &.two {
    transform:scale(1);
    .modal-background {
      background:rgba(0,0,0,.0);
      animation: fadeIn .5s cubic-bezier(0.165, 0.840, 0.440, 1.000) forwards;
      .modal {
        opacity:0;
        animation: scaleUp .5s cubic-bezier(0.165, 0.840, 0.440, 1.000) forwards;
      }
    }
    + .content {
      animation: scaleBack .5s cubic-bezier(0.165, 0.840, 0.440, 1.000) forwards;
    }
    &.out {
      animation: quickScaleDown 0s .5s linear forwards;
      .modal-background {
        animation: fadeOut .5s cubic-bezier(0.165, 0.840, 0.440, 1.000) forwards;
        .modal {
           animation: scaleDown .5s cubic-bezier(0.165, 0.840, 0.440, 1.000) forwards;
        }
      }
      + .content {
        animation: scaleForward .5s cubic-bezier(0.165, 0.840, 0.440, 1.000) forwards;
      }
    }
  }
  &.three {
    z-index:0;
    transform:scale(1);
    .modal-background {
      background:rgba(0,0,0,.6);
      .modal {
        animation: moveUp .5s cubic-bezier(0.165, 0.840, 0.440, 1.000) forwards;
      }
    }
    + .content {
      z-index:1;
      animation: slideUpLarge .5s cubic-bezier(0.165, 0.840, 0.440, 1.000) forwards;
    }
    &.out {
      .modal-background {
        .modal {
          animation: moveDown .5s cubic-bezier(0.165, 0.840, 0.440, 1.000) forwards;
        }
      }
      + .content {
        animation: slideDownLarge .5s cubic-bezier(0.165, 0.840, 0.440, 1.000) forwards;
      }
    }
  }
  &.four {
    z-index:0;
    transform:scale(1);
    .modal-background {
      background:rgba(0,0,0,.7);
      .modal {
        animation: blowUpModal .5s cubic-bezier(0.165, 0.840, 0.440, 1.000) forwards;
      }
    }
    + .content {
      z-index:1;
      animation:blowUpContent .5s cubic-bezier(0.165, 0.840, 0.440, 1.000) forwards;
    }
    &.out {
      .modal-background {
        .modal {
          animation: blowUpModalTwo .5s cubic-bezier(0.165, 0.840, 0.440, 1.000) forwards;
        }
      }
      + .content {
        animation: blowUpContentTwo .5s cubic-bezier(0.165, 0.840, 0.440, 1.000) forwards;
      }
    }
  }
  &.five {
    transform:scale(1);
    .modal-background {
      background:rgba(0,0,0,.0);
      animation: fadeIn .5s cubic-bezier(0.165, 0.840, 0.440, 1.000) forwards;
      .modal {
        transform:translateX(-1500px);
        animation: roadRunnerIn .3s cubic-bezier(0.165, 0.840, 0.440, 1.000) forwards;
      }
    }
    &.out {
      animation: quickScaleDown 0s .5s linear forwards;
      .modal-background {
        animation: fadeOut .5s cubic-bezier(0.165, 0.840, 0.440, 1.000) forwards;
        .modal {
          animation: roadRunnerOut .5s cubic-bezier(0.165, 0.840, 0.440, 1.000) forwards;
        }
      }
    }
  }
  &.six {
    transform:scale(1);
    .modal-background {
      background:rgba(0,0,0,.0);
      animation: fadeIn .5s cubic-bezier(0.165, 0.840, 0.440, 1.000) forwards;
      .modal {
        background-color:transparent;
        animation: modalFadeIn .5s .8s cubic-bezier(0.165, 0.840, 0.440, 1.000) forwards;
        h2,p {
          opacity:0;
          position:relative;
          animation: modalContentFadeIn .5s 1s cubic-bezier(0.165, 0.840, 0.440, 1.000) forwards;
        }
        .modal-svg {
          rect {
            animation: sketchIn .5s .3s cubic-bezier(0.165, 0.840, 0.440, 1.000) forwards;
          }
        }
      }
    }
    &.out {
      animation: quickScaleDown 0s .5s linear forwards;
      .modal-background {
        animation: fadeOut .5s cubic-bezier(0.165, 0.840, 0.440, 1.000) forwards;
        .modal {
          animation: modalFadeOut .5s cubic-bezier(0.165, 0.840, 0.440, 1.000) forwards;
          h2,p {
            animation: modalContentFadeOut .5s cubic-bezier(0.165, 0.840, 0.440, 1.000) forwards;
          }
          .modal-svg {
            rect {
              animation: sketchOut .5s cubic-bezier(0.165, 0.840, 0.440, 1.000) forwards;
            }
          }
        }
      }
    }
  }
  &.seven {
    transform:scale(1);
    .modal-background {
      background:rgba(0,0,0,.0);
      animation: fadeIn .5s cubic-bezier(0.165, 0.840, 0.440, 1.000) forwards;
      .modal {
        height:75px;
        width:75px;
        border-radius:75px;
        overflow:hidden;
        animation: bondJamesBond 1.5s cubic-bezier(0.165, 0.840, 0.440, 1.000) forwards;
        h2,p {
          opacity:0;
          position:relative;
          animation: modalContentFadeIn .5s 1.4s linear forwards;
        }
      }
    }
    &.out {
      animation: slowFade .5s 1.5s linear forwards;
      .modal-background {
        background-color:rgba(0,0,0,.7);
        animation: fadeToRed 2s cubic-bezier(0.165, 0.840, 0.440, 1.000) forwards;
        .modal {
          border-radius:3px;
          height:162px;
          width:227px;
          animation: killShot 1s cubic-bezier(0.165, 0.840, 0.440, 1.000) forwards;
          h2,p {
            animation:modalContentFadeOut .5s .5 cubic-bezier(0.165, 0.840, 0.440, 1.000) forwards;
          }
        }
      }
    }
  }
  .modal-background {
    display:table-cell;
    background:rgba(0,0,0,.8);
    text-align:center;
    vertical-align:middle;
    .modal {
      background:white;
      padding:50px 35px;
      display:inline-block;
      border-radius:3px;
      font-weight:300;
      position:relative;
      h2 {
        font-size:25px;
        line-height:25px;
        margin-bottom:15px;
      }
      p {
        font-size:18px;
        line-height:15px;
      }
      .modal-svg {
        position:absolute;
        top:0;
        left:0;
        height:100%;
        width:100%;
        border-radius:3px;
        rect {
          stroke: #fff;
          stroke-width: 2px;
          stroke-dasharray: 778;
          stroke-dashoffset: 778;
        }
      }
    }
  }
}

.content {
  min-height:100%;
  height:100%;
  background:white;
  position:relative;
  z-index:0;
  h1 {
    padding:75px 0 30px 0;
    text-align:center;
    font-size:30px;
    line-height:30px;
  }
  .buttons {
    max-width:800px;
    margin:0 auto;
    padding:0;
    text-align:center;
    .button {
      display:inline-block;
      text-align:center;
      padding:10px 15px;
      margin:10px;
      background:red;
      font-size:18px;
      background-color:#efefef;
      border-radius:3px;
      box-shadow:0 1px 2px rgba(0,0,0,.3);
      cursor:pointer;
      &:hover {
        color:white;
        background:#009bd5;
      }
    }
  } 
}

@keyframes unfoldIn {
  0% {
    transform:scaleY(.005) scaleX(0);
  }
  50% {
    transform:scaleY(.005) scaleX(1);
  }
  100% {
    transform:scaleY(1) scaleX(1);
  }
}

@keyframes unfoldOut {
  0% {
    transform:scaleY(1) scaleX(1);
  }
  50% {
    transform:scaleY(.005) scaleX(1);
  }
  100% {
    transform:scaleY(.005) scaleX(0);
  }
}

@keyframes zoomIn {
  0% {
    transform:scale(0);
  }
  100% {
    transform:scale(1);
  }
}

@keyframes zoomOut {
  0% {
    transform:scale(1);
  }
  100% {
    transform:scale(0);
  }
}

@keyframes fadeIn {
  0% {
    background:rgba(0,0,0,.0);
  }
  100% {
    background:rgba(0,0,0,.7);
  }
}

@keyframes fadeOut {
  0% {
    background:rgba(0,0,0,.7);
  }
  100% {
    background:rgba(0,0,0,.0);
  }
}

@keyframes scaleUp {
  0% {
    transform:scale(.8) translateY(1000px);
    opacity:0;
  }
  100% {
    transform:scale(1) translateY(0px);
    opacity:1;
  }
}

@keyframes scaleDown {
  0% {
    transform:scale(1) translateY(0px);
    opacity:1;
  }
  100% {
    transform:scale(.8) translateY(1000px);
    opacity:0;
  }
}

@keyframes scaleBack {
  0% {
    transform:scale(1);
  }
  100% {
    transform:scale(.85);
  }
}

@keyframes scaleForward {
  0% {
    transform:scale(.85);
  }
  100% {
    transform:scale(1);
  }
}

@keyframes quickScaleDown {
  0% {
    transform:scale(1);
  }
  99.9% {
    transform:scale(1);
  }
  100% {
    transform:scale(0);
  }
}

@keyframes slideUpLarge {
  0% {
    transform:translateY(0%);
  }
  100% {
    transform:translateY(-100%);
  }
}

@keyframes slideDownLarge {
  0% {
    transform:translateY(-100%);
  }
  100% {
    transform:translateY(0%);
  }
}

@keyframes moveUp {
  0% {
    transform:translateY(150px);
  }
  100% {
    transform:translateY(0);
  }
}

@keyframes moveDown {
  0% {
    transform:translateY(0px);
  }
  100% {
    transform:translateY(150px);
  }
}

@keyframes blowUpContent {
  0% {
    transform:scale(1);
    opacity:1;
  }
  99.9% {
    transform:scale(2);
    opacity:0;
  }
  100% {
    transform:scale(0);
  }
}

@keyframes blowUpContentTwo {
  0% {
    transform:scale(2);
    opacity:0;
  }
  100% {
    transform:scale(1);
    opacity:1;
  }
}

@keyframes blowUpModal {
  0% {
    transform:scale(0);
  }
  100% {
    transform:scale(1);
  }
}

@keyframes blowUpModalTwo {
  0% {
    transform:scale(1);
    opacity:1;
  }
  100% {
    transform:scale(0);
    opacity:0;
  }
}

@keyframes roadRunnerIn {
  0% {
    transform:translateX(-1500px) skewX(30deg) scaleX(1.3);
  }
  70% {
    transform:translateX(30px) skewX(0deg) scaleX(.9);
  }
  100% {
    transform:translateX(0px) skewX(0deg) scaleX(1);
  }
}

@keyframes roadRunnerOut {
  0% {
    transform:translateX(0px) skewX(0deg) scaleX(1);
  }
  30% {
    transform:translateX(-30px) skewX(-5deg) scaleX(.9);
  }
  100% {
    transform:translateX(1500px) skewX(30deg) scaleX(1.3);
  }
}

@keyframes sketchIn {
	0% {
		stroke-dashoffset: 778;
	}
	100% {
		stroke-dashoffset: 0;
	}
}

@keyframes sketchOut {
	0% {
		stroke-dashoffset: 0;
	}
	100% {
		stroke-dashoffset: 778;
	}
}

@keyframes modalFadeIn {
  0% {
    background-color:transparent;
  }
  100% {
    background-color:white;
  }
}

@keyframes modalFadeOut {
  0% {
    background-color:white;
  }
  100% {
    background-color:transparent;
  }
}

@keyframes modalContentFadeIn {
  0% {
    opacity:0;
    top:-20px;
  }
  100% {
    opacity:1;
    top:0;
  }
}

@keyframes modalContentFadeOut {
  0% {
    opacity:1;
    top:0px;
  }
  100% {
    opacity:0;
    top:-20px;
  }
}

@keyframes bondJamesBond {
  0% {
    transform:translateX(1000px);
  }
  80% {
    transform:translateX(0px);
    border-radius:75px;
    height:75px;
    width:75px;
  }
  90% {
    border-radius:3px;
    height:182px;
    width:247px;
  }
  100% {
    border-radius:3px;
    height:162px;
    width:227px;
  }
}

@keyframes killShot {
  0% {
    transform:translateY(0) rotate(0deg);
    opacity:1;
  }
  100% {
    transform:translateY(300px) rotate(45deg);
    opacity:0;
  }
}

@keyframes fadeToRed {
  0% {
    background-color:rgba(black,.6);
  }
  100% {
    background-color:rgba(red,.8);
  }
}

@keyframes slowFade {
  0% {
    opacity:1;
  }
  99.9% {
    opacity:0;
    transform:scale(1);
  }
  100% {
    transform:scale(0);
  }
}
</style>